import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  EMAIL_PLACEHOLDER,
  FIELD_EMAIL_VALID,
  FIELD_REQUIRED,
  MODAL_CREATE_ACCOUNT_TITLE,
} from "../../../i18n/keysTranslations";
import { REGEX_EMAIL } from "../../../utils/regex";
import TextField from "../../../components/Form/TextField";
import { useTranslationApp } from "../../../lib/i18next";

const RegisterEmailStep = ({ control, errors }) => {
  const { t } = useTranslationApp();

  return (
    <>
      <Box sx={{ mb: 1 }}>
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          {t(MODAL_CREATE_ACCOUNT_TITLE)}
        </Typography>
      </Box>

      <TextField
        fullWidth
        id="register-demo-email"
        label={t(EMAIL_PLACEHOLDER)}
        name="email"
        variant="filled"
        color="primary"
        InputLabelProps={{ shrink: true }}
        control={control}
        rules={{
          required: {
            value: true,
            message: t(FIELD_REQUIRED),
          },
          validate: {
            emailValid: (value) => {
              if (!REGEX_EMAIL.test(value)) {
                return t(FIELD_EMAIL_VALID);
              }
            },
          },
        }}
        errors={errors}
      />
    </>
  );
};

export default RegisterEmailStep;
